import { render, staticRenderFns } from "./SlideShow.vue?vue&type=template&id=6bef8954&"
import script from "./SlideShow.vue?vue&type=script&lang=js&"
export * from "./SlideShow.vue?vue&type=script&lang=js&"
import style0 from "./SlideShow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports